import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Settings } from '../../common/types/types';

interface SettingsState {
  settings: Settings[];
}

const initialState: SettingsState = {
  settings: [],
};

const SettingsSlice = createSlice({
  name: 'Settings',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setSettings: (state, action: PayloadAction<Settings[]>) => {
      return { ...state, setSettings: action.payload };
    },
  },
});

export const { reset, setSettings } = SettingsSlice.actions;
export default SettingsSlice.reducer;
